import styled, { css } from 'styled-components';
import { Flex } from 'components/Flex';

export const ShiftConflictCardWrapper = styled.div`
  position: relative;
  padding: 12px;
  width: 100%;
  min-height: 110px;
  background-color: ${({ theme }) => theme.colors.White};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  ${({ theme }) => css`
    ${theme.borders.DefaultBorder};
    ${theme.shadows.Default};
  `}
`;

export const ShiftSectionA = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 24px;
`;

export const ShiftID = styled.div`
  ${({ theme }) => theme.typography.Body}
  font-size: 14px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-weight: 500;
  margin-top: 8px;
`;

export const PositionText = styled.div`
  color: ${({ theme }) => theme.colors.AccentPurple};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
`;

export const ShiftDate = styled.div`
  ${({ theme }) => theme.typography.Body}
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 325px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const ReleaseShiftLink = styled.div`
  ${({ theme }) => theme.typography.TextLink};
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
  margin-top: 8px;
`;

export const AvatarIconWrapper = styled.div`
  position: relative;
  margin-right: 8px;
`;

export const HeaderWrapper = styled(Flex)`
  padding: 32px 0px 0px 0px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  flex-grow: 1;
`;

export const MainTitleContainer = styled(Flex)`
  padding: 0px 10px 0px 30px;
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 28px;
  font-weight: 600;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    padding: 0 20px;
    flex-direction: column;
  }
`;

export const ContentWrapper = styled(Flex)`
  padding: 40px 10px 0px 30px;
  flex-direction: column;
  gap: 30px;
  ${({ theme }) => theme.fonts.Poppins};
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const ConflictNote = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  width: 95%;
`;
